module.exports = __webpack_public_path__ + "static/media/step-big-blank.266ae489.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Icons/step-big-blank.svg
// module id = 853
// module chunks = 21